export default {
  homeCustom: state => state.homeCustom,
  homeBusi: state => state.homeBusi,
  homeContract: state => state.homeContract,
  homeCustomVisit: state => state.homeCustomVisit,
  homeChartData: state => state.homeChartData,
  homeProject: state => state.homeProject,
  homeMedicalCustomer: state => state.homeMedicalCustomer,
};
